import { Button } from 'blaze-ui/Button'
import { EditorView } from 'prosemirror-view'
import { Modal, useModals } from 'almanac-ui/Modal'
import { useDefaultFolder } from 'hooks/queries/projects/useDefaultFolder'
import { useCurrentFolderStore } from 'hooks/stores/useCurrentFolderStore'
import { ChannelType } from 'components/CampaignCreationModal/Types'
import Styles from './CreateNewPostModal.module.scss'
import { Heading } from 'blaze-ui/Heading/Heading'
import { ScheduledPostShow } from 'api/clients/ScheduledPostsClient'
import { Chip } from 'components/Chip/Chip'
import { Formik, Form } from 'formik'

import { FilePathFormikField } from 'components/Wizards/FilePathFormikField/FilePathFormikField'
import { ChannelIcon } from 'components/ChannelIcon/ChannelIcon'
import { useCrossPost } from './useCrossPost'
import { ArticleMeta } from 'types'
import useResponsiveDesign from 'hooks/useResponsiveDesign'
import { useIsSystemRedesign } from 'hooks/useIsSystemRedesign'

interface Props {
  view?: EditorView
  postTitle: string
  articleChannel?: ChannelType
  scheduledPost?: ScheduledPostShow
  article?: ArticleMeta
}

export const CreateNewPostModal = ({ view, postTitle, articleChannel, scheduledPost, article }: Props) => {
  const isSystemRedesignEnabled = useIsSystemRedesign()
  const defaultFolder = useDefaultFolder()
  const { currentFolder } = useCurrentFolderStore()
  const { closeModal } = useModals()
  const { isMobile } = useResponsiveDesign()
  const { handleSubmit, validationSchema, channel, setChannel, selectionChannels } = useCrossPost({
    view,
    articleChannel,
    scheduledPost,
    article,
  })

  return (
    <Modal.Root>
      <Modal.Header title={'Create New Cross Post'} />
      <Formik
        initialValues={{ filename: postTitle || '', project: currentFolder || defaultFolder }}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {({ errors, touched }) => (
          <Form>
            <Modal.Content>
              <div className={Styles.contentContainer}>
                <div className={Styles.filePickerContainer}>
                  <Heading level={5}>
                    Name your doc and select a location<div className={Styles.redAsterisk}>*</div>
                  </Heading>
                  <FilePathFormikField locationPickerVariant="tertiary" locationPickerFullWidth={isMobile} />
                </div>
                <div className={Styles.newPostSection}>
                  <Heading level={5}>Post Type</Heading>
                  <div className={Styles.channelContainer}>
                    {selectionChannels.map((selectionChannel) => (
                      <Chip
                        deletable={false}
                        key={selectionChannel.key}
                        isSelected={selectionChannel.key === channel}
                        variant="catalogue"
                        onPress={() => setChannel(selectionChannel.key)}
                      >
                        <ChannelIcon
                          isWhite={selectionChannel.key === channel && !isSystemRedesignEnabled}
                          channel={selectionChannel.key}
                        />
                        {selectionChannel.title}
                      </Chip>
                    ))}
                  </div>
                </div>
              </div>
            </Modal.Content>
            <Modal.Footer>
              <Modal.FooterContent slot="left">
                {!isMobile && (
                  <Button variant="tertiary" onPress={closeModal}>
                    Cancel
                  </Button>
                )}
              </Modal.FooterContent>
              <Modal.FooterContent slot="right">
                <Button type="submit" variant="primary" size={isMobile ? 'xl' : 'md'}>
                  Create Post
                </Button>
              </Modal.FooterContent>
            </Modal.Footer>
          </Form>
        )}
      </Formik>
    </Modal.Root>
  )
}
